import styled from 'styled-components';
import { rem } from 'polished';
import { TrimSelectTemplate } from './TrimSelectTemplate';

export const TrimSelectStyled = styled(TrimSelectTemplate)`
    padding: 0 0 ${rem(40)} 0;
    position: relative;

    .isDisabled {
        pointer-events: none;
        opacity: 0.5;
    }

    .trimTitle,
    .trimDescription,
    .trimPrice {
        display: block;
    }

    .trims {
        position: relative;
    }

    .trim {
        border: 1px solid ${({ theme }) => theme.colors.primaryDisabled};
        cursor: pointer;
        margin: ${rem(8)} 0;
        width: 100%;
        background: none;
        text-align: left;
        padding: 0;

        &.isSelected,
        &:hover,
        &:focus-visible {
            border: 1px solid ${({ theme }) => theme.colors.primary};
            .inner {
                border-color: ${({ theme }) => theme.colors.primary};
            }
        }

        .inner {
            border: 1px solid transparent;
            padding: ${rem(24)} ${rem(24)} ${rem(24)} ${rem(64)};
        }
    }

    .trimTitle {
        color: ${({ theme }) => theme.colors.black2};
        font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        position: relative;

        .icon {
            border: 1px solid #73767a;
            width: ${rem(24)};
            height: ${rem(24)};
            position: absolute;
            left: -${rem(40)};
            top: -${rem(2)};
            border-radius: 50%;

            .selected {
                background: ${({ theme }) => theme.colors.primary};
                width: ${rem(12)};
                height: ${rem(12)};
                position: absolute;
                top: ${rem(5)};
                left: ${rem(5)};
                border-radius: 50%;
            }
        }
    }

    .trimContent {
        font-size: ${({ theme }) => theme.fontSizes.textSupBase};

        &.title {
            margin-top: ${rem(16)};
        }

        &.description {
            color: ${({ theme }) => theme.colors.grey31};
        }
    }

    .trimPrice {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        padding-bottom: ${rem(16)};
    }

    .or {
        text-transform: lowercase;
    }

    .currencyLabel__suffix--TTC {
        padding-left: 0;
    }

    .trimDescription {
        padding: ${rem(5)} ${rem(0)} ${rem(16)} ${rem(0)};
    }
`;
